import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { SocialContacs } from '@modules/types/graphql';

export type Entity = Partial<SocialContacs> | null;

@DecribeEntity('SocialsEntity')
class SocialsEntity extends BaseEntity {
    vk: string;
    telegram: string;

    constructor(socials: Entity) {
        super(socials);

        this.vk = socials?.vk ?? '';
        this.telegram = socials?.telegram ?? '';
    }
}

export { SocialsEntity };
